import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import Dropdown from '../../../components/Dropdown/ReactDropdown';
import { Calendar, EditSquare, Question } from '../../../components/Icon';
import { IsOpen } from '../../../components/Icon';

import { getDate, getExpiryDateColor } from '../helpers';
import { selectConfig, selectWork, selectWorks } from '../../Api/selectors';
import { deleteVehicleProperty, fetchVehicle, setVehicleProperties } from '../actions';
import {
  VEHICLE_FUEL_TYPES,
  VEHICLE_BODY_TYPES,
  VEHICLE_COLORS,
  VEHICLE_DRIVE_TYPES,
  VEHICLE_TRANSMISSION_TYPES,
  REQUEST_VEHICLE,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  REQUEST_VEHICLE_PROPERTIES,
} from '../constants';
import { VEHICLE_DETAILS_VEHICLE_DATA_CARD } from '../constants';
import env from '../../../env';
import { formatLicensePlate } from '../../../utils/string';
import cn from 'classnames';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import styles from './CardData.module.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { RETRIEVE_VEHICLE_TVI } from '../../ORB/constants';
import { retrieveVehicleTVI } from '../../ORB/actions';
import { Warning } from '../../../components/Warnings';
import { Loader } from 'react-feather';
import { AppClientId } from '../../Shared/constants';
import { Permission } from '../../../components/Permission';
import { INVOICES_PAGE } from '../../../components/Permission/constants';


dayjs.extend(customParseFormat);

const Container = styled.div`
  .card-title {
    white-space: nowrap;
  }

  .button-block {
    width: 50%;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .winTooltip {
    width: 41px;
    height: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4px;
  }

  .info-cell {
    white-space: nowrap;
  }
  .info-cell--multiline {
    white-space: normal;
  }

  .info-cell:hover {
    cursor: pointer;
  }

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }
  .icon-edit-square {
    color: #d9d9d9;
  }

  img {
    margin: 10, 0, 0, 0;
  }

  .dropdown-wrapper {
    .dropdown-card {
      height: 35px;
    }
  }
  .red-text {
    color: crimson;
    font-weight: 600;
  }

  .orange-text {
    color: DarkOrange;
    font-weight: 600;
  }
`;

const STATE = {
  isOpen: false,
  isEditVehicle: false,
};

const DROPDOWN_OPTIONS = {
  body_type: VEHICLE_BODY_TYPES,
  base_color: VEHICLE_COLORS,
  secondary_color: VEHICLE_COLORS,
  transmission_type: VEHICLE_TRANSMISSION_TYPES,
  fuel_type: VEHICLE_FUEL_TYPES,
  power_axle: VEHICLE_DRIVE_TYPES,
};
/* eslint-disable react/prefer-stateless-function */
class VehicleDataCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    VEHICLE_DETAILS_VEHICLE_DATA_CARD.map(property => {
      if (this.props.vehicle[property]) {
        this.setState({ [property]: this.props.vehicle[property] });
      }
    });
  }

  handleEdit() {
    this.setState({ isEditVehicle: true });
  }

  retrieveVehicleTVI(regplate, meldcode) {
    this.props.retrieveVehicleTVI(regplate, meldcode, res => {
      if (!res.chassisnummer && !meldcode) {
        this.setState({ showGetVinMsg: this.lbl('vehicle.create.vin.meldcodeRequired') });
      }
      if (!res.chassisnummer && meldcode) {
        this.setState({ showGetVinMsg: this.lbl('vehicle.create.vin.meldcodeIncorrect') });
      }
      if (res.chassisnummer) {
        this.setState({ vin: `${res.chassisnummer}${meldcode}`, showGetVinMsg: '' });
      }
    });
  }

  dropdown(type) {
    const vals = DROPDOWN_OPTIONS[type];

    const options = vals.map(val => ({
      label: this.lbl(`vehicle.property.${type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.state[type]);

    return (
      <div className={styles.container}>
        <Dropdown
          controlClassName={'dropdown-card'}
          options={options}
          value={value}
          onChange={pair => this.setState({ [type]: pair.value })}
          className={styles.dropdown}
        />
      </div>
    );
  }

  input(type) {
    return (
      <input
        className="form-control"
        value={this.state[type]}
        onChange={evt => this.setState({ [type]: evt.target.value })}
      />
    );
  }

  isImportDisabled() {
    return !!this.props?.vehicle?.incoming_invoice;
  }

  checkbox(type) {
    let disabled = false;
    if (type === 'import') disabled = this.isImportDisabled();
    return (
      <CheckboxComponent
        onChange={() => {
          if (!this.state.isEditVehicle) return;
          this.state[type] == '1' ? this.setState({ [type]: '0' }) : this.setState({ [type]: '1' });
        }}
        checked={this.state[type] == '1'}
        disabled={disabled}
      />
    );
  }

  datePicker(type) {
    let defaultFormat = type === 'HOOI_inslag_done_date' ? 'DD-MM-YYYY HH:mm' : 'DD-MM-YYYY';
    let format = this.state[type]?.charAt?.(2) == '-' ? defaultFormat : undefined;

    let selected = this.state[type] && this.state[type] !== 'null' && dayjs(this.state[type], format);
    return (
      <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
        <DatePicker
          className={styles.datePicker}
          showTimeInput={type === 'HOOI_inslag_done_date'}
          dateFormat={type === 'HOOI_inslag_done_date' ? 'dd-MM-yyyy HH:mm' : 'dd-MM-yyyy'}
          selected={selected && selected != 'Invalid Date' && selected.toDate()}
          onChange={date => {
            let d = dayjs(date).format(defaultFormat);
            this.setState({ [type]: d });
          }}
        />
        <Calendar className={styles.iconCalendar} />
      </div>
    );
  }

  isShowPropertyCell(type) {
    if (this.state.isEditVehicle && this.props.vehicle[type]) {
      return true;
    }
    if (this.props.vehicle[type] && this.props.vehicle[type] !== 'null' && !this.state.isEditVehicle) {
      return true;
    }
    return false;
  }

  edit() {
    let properties = [];
    VEHICLE_DETAILS_VEHICLE_DATA_CARD.map(type => {
      if (type === 'import' && this.state[type]) {
        properties.push({
          propertyName: type,
          propertyValue: !this.state['regplate']?.trim().length ? '1' : this.state[type],
        });
      }

      if (this.state[type] && type !== 'import') {
        properties.push({
          propertyName: type,
          propertyValue: this.state[type],
        });
      }
    });

    this.props.patch(properties, callback => {
      this.reset();
    });
  }

  reset() {
    this.setState({ ...STATE });
  }

  resetProps() {
    VEHICLE_DETAILS_VEHICLE_DATA_CARD.map(property => {
      // if (this.props.vehicle[property] && (property === 'date_first_allowance' || property === 'date_expected')) {
      //   let d = dayjs(this.props.vehicle[property]).format('YYYY-MM-DD hh:mm:ss');
      //   this.setState({ [property]: d, isOpen: false, isEditVehicle: false });
      //   return;
      // }
      if (this.props.vehicle[property]) {
        this.setState({ [property]: this.props.vehicle[property], isOpen: false, isEditVehicle: false });
      }
    });
  }

  fieldDisabledForInstallation(name) {
    switch (name) {
      case 'import':
        return this.props.serverConfig.disabledImport;
      default:
        return false;
    }
  }

  render() {
    const vehicle = this.props.vehicle;

    // if (this.props.work) return <LoadingDetailsPageCard />;

    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          <HBox className={styles.header}>
            <h2 className="card-title mb-0 text-muted">{this.lbl('vehicle.info.data.vehicle_data')}</h2>
            {window.innerWidth > 768 && (
              <div
                className="icon-block"
                onClick={() => {
                  this.setState(prevState => ({
                    isEditVehicle: !prevState.isEditVehicle,
                  }));
                }}
              >
                <FontAwesomeIcon icon={faPen} size="xs" />

                {/* <EditSquare className={styles.iconEditSquare} />  */}
              </div>
            )}

            {window.innerWidth <= 768 && this.state.isOpen && (
              <div
                className="icon-block"
                onClick={() => {
                  this.setState(prevState => ({
                    isEditVehicle: !prevState.isEditVehicle,
                  }));
                }}
              >
                <EditSquare className={styles.iconEditSquare} />
              </div>
            )}

            {window.innerWidth <= 768 && (
              <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                <IsOpen />
              </div>
            )}
          </HBox>

          {(this.state.isOpen || window.innerWidth > 768) && (
            <>
              {VEHICLE_DETAILS_VEHICLE_DATA_CARD.map(property => {
                if (this.isShowPropertyCell(property) && property === 'mileage') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.input(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            {parseInt(vehicle[property] || '0').toLocaleString() + '  km'}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (property === 'new_from_factory' && env.clientId != AppClientId.AUTOWIENTJES) {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <div className={styles.checkbox}>
                          <label className={cn('form-label', styles.labelCheckbox)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.checkbox(property)}
                        </div>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{this.checkbox(property)}</div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (property === 'import') {
                  return !this.fieldDisabledForInstallation(property) ? (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <div className={styles.checkbox}>
                          <label className={cn('form-label', styles.labelCheckbox)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.checkbox(property)}
                        </div>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{this.checkbox(property)}</div>
                        </div>
                      )}
                    </div>
                  ) : (
                    ''
                  );
                }

                if (property === 'vin') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.input(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                          {!!vehicle[property] && vehicle[property] !== 'null' && vehicle[property].trim()}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (property === 'meldcode') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          <HBox>
                            <div className="flex-grow-1">{this.input(property)}</div>
                            {env.clientId === AppClientId.AUTOWIENTJES && (
                              <>
                                <div className="flex-0">
                                  <HBox>
                                    <ButtonComponent
                                      style={'ButtonSoftPrimary'}
                                      disabled={!this.props.vehicle?.id || !this.state?.regplate || this.props.workTVI}
                                      onClick={() => this.retrieveVehicleTVI(this.state?.regplate, this.state?.meldcode)}
                                    >
                                      {this.props.workTVI ? <Loader small /> : this.lbl('vehicle.create.vin.retrieve')}
                                    </ButtonComponent>
                                    <div className="winTooltip" title="Enter regplate and meldcode to enable button">
                                      <Question />
                                    </div>
                                  </HBox>
                                </div>
                              </>
                            )}
                          </HBox>
                          <div>{!!this.state.showGetVinMsg && <Warning>{this.state.showGetVinMsg}</Warning>}</div>
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            {!!vehicle[property] && vehicle[property] !== 'null' ? (
                              vehicle[property]
                            ) : env.clientId === AppClientId.AUTOWIENTJES ? (
                              <>
                                <div className="d-flex">
                                  <ButtonComponent
                                    style={'ButtonSoftPrimary'}
                                    disabled={!this.props.vehicle?.id || !this.state?.regplate || this.props.workTVI}
                                    onClick={() => this.retrieveVehicleTVI(this.state?.regplate, this.state?.meldcode)}
                                  >
                                    {this.props.workTVI ? <Loader small /> : this.lbl('vehicle.create.vin.retrieve')}
                                  </ButtonComponent>
                                  <div className="winTooltip" title="Enter regplate and meldcode to enable button">
                                    <Question />
                                  </div>
                                </div>
                                {!!this.state.showGetVinMsg && <Warning>{this.state.showGetVinMsg}</Warning>}
                              </>
                            ) : null}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'regplate') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.input(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{formatLicensePlate(vehicle[property])}</div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (property === 'date_apk_expiry' && !this.state.isEditVehicle) {
                  if (vehicle[property]) {
                    // Check if vehicle[property] is not null or undefined

                    const dateParts = vehicle[property].split('-');
                    const apkExpiryDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);

                    const today = new Date();
                    const twoMonthsFromNow = new Date();
                    twoMonthsFromNow.setMonth(today.getMonth() + 2);

                    let color = '';

                    if (!this.fieldDisabledForInstallation(property)) {
                      if (apkExpiryDate < today) {
                        color = 'red-text';
                      } else if (apkExpiryDate >= today && apkExpiryDate <= twoMonthsFromNow) {
                        color = 'orange-text';
                      }

                      return (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={cn(getExpiryDateColor(vehicle[property]), styles.labelTable)}>
                            {getDate(vehicle[property])}
                          </div>
                          {/* <Cell className={getExpiryDateColor(vehicle[property])}>{vehicle[property]}</Cell> */}
                        </div>
                      );
                    } else {
                      return '';
                    }
                  } else {
                    // Handle the case where vehicle[property] is null or undefined
                    // You can return a default value or handle it according to your requirements
                    return '';
                  }
                }

                if (property === 'ex_rental' && env.clientId != AppClientId.AUTOWIENTJES) {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <div className={styles.checkbox}>
                          <label className={cn('form-label', styles.labelCheckbox)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.checkbox(property)}
                        </div>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{this.checkbox(property)}</div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (property === 'has_instruction_book' && vehicle[property]) {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                        <div className={styles.labelTable}>
                          {vehicle[property] === '1'
                            ? this.lbl(`vehicle.inspection.present`)
                            : vehicle[property] === '2'
                            ? this.lbl(`vehicle.inspection.flaw`)
                            : ''}
                        </div>
                      </div>
                    </div>
                  );
                }

                if (property === 'has_maintenance_book' && vehicle[property]) {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                        <div className={styles.labelTable}>
                          {vehicle[property] === '1'
                            ? this.lbl(`vehicle.inspection.present`)
                            : vehicle[property] === '2'
                            ? this.lbl(`vehicle.inspection.flaw`)
                            : ''}
                        </div>
                      </div>
                    </div>
                  );
                }

                //only hooikammer

                if (property === 'HOOI_inslag_done_date') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.datePicker(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{getDate(vehicle[property])}</div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (property === 'HOOI_uitslag_done_date') {
                  return (
                    <Permission permission={INVOICES_PAGE}>
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.datePicker(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{getDate(vehicle[property])}</div>
                        </div>
                      )}
                    </div>
                    </Permission>
                  );
                }

                if (property === 'takeout_details') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <div className={styles.checkbox}>
                          <label className={cn('form-label', styles.labelCheckbox)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {vehicle[property]}
                        </div>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{vehicle[property]}</div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (property === 'task_labels' || property === 'HOOI_NEW_TASK_check_in') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <div className={styles.checkbox}>
                          <label className={cn('form-label', styles.labelCheckbox)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.checkbox(property)}
                        </div>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{this.checkbox(property)}</div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (property === 'HOOI_uitslag_done') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <div className={styles.checkbox}>
                          <label className={cn('form-label', styles.labelCheckbox)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.checkbox(property)}
                        </div>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{this.checkbox(property)}</div>
                        </div>
                      )}
                    </div>
                  );
                }

                //till this is hooikammer

                if (this.isShowPropertyCell(property) && property === 'power') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.input(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{vehicle[property]} KW</div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'battery_capacity') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.input(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{vehicle[property]} KW/h</div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'date_apk_expiry') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.datePicker(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{getDate(vehicle[property])}</div>
                        </div>
                      )}
                    </div>
                  );
                }
                if (this.isShowPropertyCell(property) && property === 'date_first_allowance') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.datePicker(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{getDate(vehicle[property])}</div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'rDWDatumEersteToelatingNationaal') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.datePicker(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{getDate(vehicle[property])}</div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'date_expected') {
                  return (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>
                          {this.datePicker(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>{getDate(vehicle[property])}</div>
                        </div>
                      )}
                    </div>
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'transmission_type') {
                  return (
                    vehicle[property] && (
                      <div className={styles.containerLabel} key={property}>
                        {this.state.isEditVehicle ? (
                          <>
                            <label className={cn('form-label', styles.label)}>
                              {this.lbl(`vehicle.property.${property}`)}
                            </label>
                            {this.dropdown(property)}
                          </>
                        ) : (
                          <div className={styles.formField}>
                            <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                            <div className={styles.labelTable}>
                              {this.lbl(`vehicle.property.${property}.${vehicle[property]}`)}
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  );
                }
                // if (this.isShowPropertyCell(property) && property === 'num_keys') {
                //   return (
                //     vehicle[property] && (
                //       <Row className="row-property" key={property}>
                //         <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                //         {this.state.isEditVehicle ? (
                //           this.dropdown(property)
                //         ) : (
                //           <Cell className="info-cell">{vehicle[property]}</Cell>
                //         )}
                //       </Row>
                //     )
                //   );
                // }
                if (this.isShowPropertyCell(property) && property === 'body_type') {
                  return (
                    this.isShowPropertyCell(property) && (
                      <div className={styles.containerLabel} key={property}>
                        {this.state.isEditVehicle ? (
                          <>
                            <label className={cn('form-label', styles.label)}>
                              {this.lbl(`vehicle.property.${property}`)}
                            </label>
                            {this.dropdown(property)}
                          </>
                        ) : (
                          <div className={styles.formField}>
                            <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                            <div className={styles.labelTable}>{vehicle[property]}</div>
                          </div>
                        )}
                      </div>
                    )
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'base_color') {
                  return (
                    this.isShowPropertyCell(property) && (
                      <div className={styles.containerLabel} key={property}>
                        {this.state.isEditVehicle ? (
                          <>
                            <label className={cn('form-label', styles.label)}>
                              {this.lbl(`vehicle.property.${property}`)}
                            </label>
                            {this.dropdown(property)}
                          </>
                        ) : (
                          <div className={styles.formField}>
                            <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                            <div className={styles.labelTable}>{vehicle[property]}</div>
                          </div>
                        )}
                      </div>
                    )
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'secondary_color') {
                  return (
                    this.isShowPropertyCell(property) && (
                      <div className="row-property" key={property}>
                        {this.state.isEditVehicle ? (
                          <>
                            <label className={cn('form-label', styles.label)}>
                              {this.lbl(`vehicle.property.${property}`)}
                            </label>
                            {this.dropdown(property)}
                          </>
                        ) : (
                          <div className={styles.formField}>
                            <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                            <div className={styles.labelTable}>{vehicle[property]}</div>
                          </div>
                        )}
                      </div>
                    )
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'power_axle') {
                  return (
                    this.isShowPropertyCell(property) && (
                      <div className={styles.containerLabel} key={property}>
                        {this.state.isEditVehicle ? (
                          <>
                            <label className={cn('form-label', styles.label)}>
                              {this.lbl(`vehicle.property.${property}`)}
                            </label>
                            {this.dropdown(property)}
                          </>
                        ) : (
                          <div className={styles.formField}>
                            <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                            <div className={styles.labelTable}>{vehicle[property]}</div>
                          </div>
                        )}
                      </div>
                    )
                  );
                }
                return (
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditVehicle ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>

                          {this.input(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={cn(styles.labelTable, styles.textRegplate)}>
                            {this.lbl(`vehicle.property.${property}.${vehicle[property]}`)}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                );
              })}
            </>
          )}

          <div>
            {this.state.isEditVehicle && (
              <div className="d-flex gap-2 mt-2">
                <ButtonComponent style={'ButtonSoftDelete'} onClick={this.resetProps.bind(this)}>
                  {this.lbl('cancel')}
                </ButtonComponent>
                &nbsp; &nbsp;
                <ButtonComponent style={'ButtonSoftEdit'} onClick={this.edit.bind(this)}>
                  {this.lbl('save')}
                </ButtonComponent>
              </div>
            )}
          </div>

          {/* <hr />
          <h2>WS2</h2>
          <SetActionStateButton01 vehicle={vehicle} propertyName="task_interior_pictures" />
          <SetActionStateButton01 vehicle={vehicle} propertyName="task_exterior_inspection" />
          <SetActionStateButton01 vehicle={vehicle} propertyName="task_exterior_pictures" />
          <SetActionStateButton01 vehicle={vehicle} propertyName="task_attach_replate" />

          <hr />
          <h2>WS3</h2>
          <SetActionStateButton01 vehicle={vehicle} propertyName="ws3_lock" />
          <SetActionStateButton0123 vehicle={vehicle} propertyName="task_interior_pictures" />
          <SetActionStateButton0123 vehicle={vehicle} propertyName="task_polish_exterior" />
          <SetActionStateButton0123 vehicle={vehicle} propertyName="task_int_ext_polish" />
          <SetActionStateButton0123 vehicle={vehicle} propertyName="task_adjust" />
          <SetActionStateButton0123 vehicle={vehicle} propertyName="task_desticker" />
          <SetActionStateButton0123 vehicle={vehicle} propertyName="task_service" />
          <SetActionStateButton0123 vehicle={vehicle} propertyName="task_apk" />
          <SetActionStateButton0123 vehicle={vehicle} propertyName="task_recall" />
          <SetActionStateButton0123 vehicle={vehicle} propertyName="task_window_repair" />
          <SetActionStateButton0123 vehicle={vehicle} propertyName="task_repair" />

          <h2>ADM_IN</h2>
          <SetActionStateButton01 vehicle={vehicle} propertyName="task_purchase_release" />
          <SetActionStateButton01 vehicle={vehicle} propertyName="task_import_papers" />
          <SetActionStateButton01 vehicle={vehicle} propertyName="task_individual_takein" />
          <SetActionStateButton01 vehicle={vehicle} propertyName="task_rdw_sample" />

          <h2>ADM_OUT</h2>
          {[
            'task_adm_out_0_enable',
            'task_adm_out_1_cancel_exports',
            'task_adm_out_2_export_plates',
            'task_adm_out_3_german_letter',
            'task_adm_out_4_move_to_weeze',
            'task_adm_out_5_sales_release',
          ].map(name => (
            <SetActionStateButton01 key={name} vehicle={vehicle} propertyName={name} />
          ))} */}
        </Container>
      </Card>
    );
  }
}

VehicleDataCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_VEHICLE,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      `${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicle?.id}`,
    ]),
    workTVI: selectWork(RETRIEVE_VEHICLE_TVI),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    patch(props, callback) {
      dispatch(setVehicleProperties(ownProps.vehicle?.id, props, callback));
    },
    deleteProperty(propertyName, callback) {
      dispatch(deleteVehicleProperty(ownProps.vehicle?.id, propertyName, callback));
    },
    fetch(callback) {
      dispatch(fetchVehicle(ownProps.vehicle?.id, callback));
    },
    // requestVehicleTVI(vehicleId, callback) {
    //   dispatch(requestVehicleTVI(vehicleId, callback));
    // },
    retrieveVehicleTVI(regplate, meldcode, callback) {
      dispatch(retrieveVehicleTVI(regplate, meldcode, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDataCard = compose(withConnect, withRouter)(VehicleDataCardComp);
